import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import paymentMethodService from "services/paymentMethodService";

export const fetchPaymentMethods = createAsyncThunk(
	"vino/paymentMethods/fetchList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			return await paymentMethodService.list();
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting payment methods",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const paymentMethodsAdapter = createEntityAdapter({});

export const {
	selectAll: selectPaymentMethods,
	selectById: selectPaymentMethodById,
} = paymentMethodsAdapter.getSelectors((state) => state.vino.paymentMethods);

const paymentMethodsSlice = createSlice({
	name: "vino/paymentMethods",
	initialState: paymentMethodsAdapter.getInitialState(),
	reducers: {},
	extraReducers: {
		[fetchPaymentMethods.fulfilled]: paymentMethodsAdapter.setAll,
	},
});

export default paymentMethodsSlice.reducer;
